import http from "./http.service";

//category
async function getCategoryList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL +
      `/category?length=${9999}&start=${0}&search=${""}&status=${"active"}`,
    payload
  );
  return response.data;
}

//product
async function getProductList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/user_products?length=${9999}`,
    payload
  );
  return response.data;
}

async function getProductInfo(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/product/${payload.id}`,
    payload
  );
  return response.data;
}

//cart
async function addCart(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/cart/items`,
    payload
  );
  return response.data;
}

async function getCartInfo(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/cart`,
    payload
  );
  return response.data;
}

async function getCartCount(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/cart_item_count`,
    payload
  );
  return response.data;
}

async function updateCart(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.put(
    process.env.REACT_APP_API_URL + `/cart/items/${payload.id}`,
    payload
  );
  return response.data;
}

async function removeCart(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.delete(
    process.env.REACT_APP_API_URL + `/cart/items/${payload.id}`,
    payload
  );
  return response.data;
}

async function clearCart(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/cart/clear_cart`,
    payload
  );
  return response.data;
}

//order
async function getOrderList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/orders`,
    payload
  );
  return response.data;
}

async function checkout(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/orders`,
    payload
  );
  return response.data;
}

//payment
async function getPaymentList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/get_all_channels`,
    payload
  );
  return response.data;
}

//profile
async function getProfile(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/profile`,
    payload
  );
  return response.data;
}

async function updateProfile(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/update_profile`,
    payload
  );
  return response.data;
}

const apiService = {
  getProductList,
  getProductInfo,
  getCategoryList,

  addCart,
  getCartInfo,
  getCartCount,
  updateCart,
  removeCart,
  clearCart,

  checkout,
  getOrderList,

  getPaymentList,

  getProfile,
  updateProfile,
};

export default apiService;
